<button
  [type]="type"
  class="app-btn"
  [ngClass]="variant"
  [class.sm]="size === 'sm'"
  [class.lg]="size === 'lg'"
  [class.full-width]="fullWidth"
  [style.width]="width"
  [disabled]="disabled"
  (click)="onClick()"
>
  <ng-content></ng-content>
</button>